<template>
  <test-reports user="agent"/>
</template>

<script>
import TestReports from '@/components/TestReports'
export default {
components:{TestReports}
}
</script>
